import React from 'react';
import PropTypes from 'prop-types';
import plusIcon from '@learningblocks/exp-constants/lib/Images/plus.svg';
import minusIcon from '@learningblocks/exp-constants/lib/Images/minus.svg';
import plusDisabled from '@learningblocks/exp-constants/lib/Images/plus-disabled.svg';
import minusDisabled from '@learningblocks/exp-constants/lib/Images/minus-disabled.svg';
import {Image} from '@learningblocks/shared-components';
import {Button} from '../Button';

import style from './style.module.scss';

export function PreciseStepper(props) {
  const preciseIncrement = () => {
    props.onChange(props.currentValue + props.step);
  };
  const preciseDecrement = () => {
    props.onChange(props.currentValue - props.step);
  };

  const underflow = () => props.currentValue === props.min;
  const overflow = () => props.currentValue === props.max;

  return (
    <>
      <Button
        className={style.stepperPrecise}
        disabled={underflow()}
        normalicon={<Image src={minusIcon} />}
        disabledicon={<Image src={minusDisabled} />}
        onClick={preciseDecrement}></Button>
      <div className={style.stepperPrecise_currentValue}>
        {props.currentValue}
      </div>
      <Button
        className={style.stepperPrecise}
        disabled={overflow()}
        normalicon={<Image src={plusIcon} />}
        disabledicon={<Image src={plusDisabled} />}
        onClick={preciseIncrement}></Button>
    </>
  );
}

PreciseStepper.propTypes = {
  /**
   * lowest value possible
   */
  min: PropTypes.number,
  /**
   * highest value possible
   */
  max: PropTypes.number,
  /**
   * current value
   */
  currentValue: PropTypes.number,
  /**
   * increment/decremnet step
   */
  step: PropTypes.number,
};
